import { useCallback, useEffect, useRef } from "react";
import { Base } from "components/template";
import { useApp } from "_hooks";
import logo from '_utilities/images/logo.png';
import { Link } from "react-router-dom";

const prefix = "v-terms";

const Terms = () => {
  const initialized = useRef(null);
  const { terms, fetchTerms } = useApp();

  const init = useCallback(() => {
    if (!initialized?.current) {
      initialized.current = true;
      fetchTerms();
    }
  }, [fetchTerms]);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <Base
      align="start"
      headerClass="flex-1"
    >
      <div className={`${prefix} container flex flex-wrap flex-col px-8 py-3 mx-auto`}>
        <div className="flex flex-wrap flex-col gap-7">
          <Link to="/" ><img src={logo} alt="logo" className="w-[55%] mx-auto mb-5 max-w-[350px] min-w-[100px]" /></Link>
          <p className="text-3xl font-bold text-center mx-auto">Términos y condiciones</p>
          <div className="text-justify" dangerouslySetInnerHTML={
            { __html: terms?.text }
          }></div>
        </div>
      </div>
    </Base>
  );
};

export default Terms;
